import { Button, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  labels: string[];
  onConfigure: () => void;
}

export const UnconfiguredAgeGroupsRow: FC<Props> = ({ labels, onConfigure }) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    gap={2}
    sx={{ bgcolor: 'background.paper', borderRadius: 1, p: 1 }}
  >
    <Typography variant="h3" color="common.grey2">
      {labels.join(', ')}
    </Typography>
    <Button variant="outlined" size="small" onClick={onConfigure}>
      <FormattedMessage id="attendance-Frequencies-Configure" />
    </Button>
  </Stack>
);
